import { render } from "./IsoZones.vue?vue&type=template&id=50ec29f8&scoped=true"
import script from "./IsoZones.vue?vue&type=script&lang=js"
export * from "./IsoZones.vue?vue&type=script&lang=js"

import "./IsoZones.vue?vue&type=style&index=0&id=50ec29f8&lang=less&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ec29f8"]])

export default __exports__